export let flex: {display: 'flex'} = {display: 'flex'};
